document.addEventListener("DOMContentLoaded", function() {
  const searchIconSVG = document.querySelector(
    "#shopify-section-sections--25513109750079__header sticky-header header details-modal details summary span span:nth-child(1) svg"
  );

  if (searchIconSVG) {
    // Hide the old SVG
    searchIconSVG.style.display = "none";

    // Insert your custom icon
    const img = document.createElement("img");
    img.src = "https://cdn.shopify.com/s/files/1/0881/1062/9183/files/Untitled_144_x_144_px_1.png?v=1762276842"; // Replace with your image
    img.style.width = "48px";
    img.style.height = "48px";
    img.style.display = "inline-block";

    searchIconSVG.parentElement.appendChild(img);
  }
});
